{
  "translation": {
    "aboutMirador": "關於Mirador項目",
    "aboutThisItem": "有關此物件",
    "addedFromUrl": "(從URL添加)",
    "addManifestUrl": "來源",
    "addManifestUrlHelp": "IIIF資源的URL",
    "addResource": "添加資源",
    "annotationCanvasLabel_1/1": "物件: [{{label}}]",
    "annotationCanvasLabel_1/2": "左方: [{{label}}]",
    "annotationCanvasLabel_2/2": "右方: [{{label}}]",
    "annotations": "標註",
    "attribution": "著作權",
    "attributionTitle": "著作權",
    "authenticationFailed": "認證失敗。",
    "authenticationRequired": "完全訪問需要認證",
    "backToResults": "返回到結果",
    "book": "書籍",
    "bottom": "下方",
    "cancel": "取消",
    "canvasIndex": "索引",
    "changeTheme": "變更佈景主題",
    "clearSearch": "清除",
    "close": "關閉",
    "closeAddResourceForm": "關閉表格",
    "closeAddResourceMenu": "關閉資源列表",
    "closeCompanionWindow": "關閉附屬視窗",
    "closeWindow": "關閉視窗",
    "collapseSection": "關閉{{section}}分頁",
    "collapseSidePanel": "關閉邊欄",
    "collection": "集合",
    "continue": "繼續",
    "copy": "複製",
    "currentItem": "目前物件",
    "currentItem_1/1": "目前物件",
    "currentItem_1/2": "左方",
    "currentItem_2/2": "右方",
    "dark": "暗色主題",
    "digitizedView": "數字視圖",
    "dismiss": "關閉信息",
    "displayNoAnnotations": "不高亮",
    "downloadExport": "滙出桌面排版",
    "downloadExportWorkspace": "滙出桌面排版",
    "elastic": "彈性",
    "elasticDescription": "在桌面上自由擺放視窗",
    "emptyResourceList": "資源列表沒有物件",
    "error": "錯誤",
    "errorDialogConfirm": "確定",
    "errorDialogTitle": "發生錯誤",
    "exitFullScreen": "退出全螢幕",
    "expandSection": "開啟{{section}}分頁",
    "expandSidePanel": "開啟邊欄",
    "exportCopied": "工作區配置被複製到你的剪貼板上了",
    "fetchManifest": "添加",
    "fullScreen": "全螢幕",
    "gallery": "矩列",
    "hideZoomControls": "隱藏縮放選項",
    "highlightAllAnnotations": "高亮所有標註",
    "iiif_homepage": "有關此資源",
    "iiif_manifest": "IIIF清單",
    "iiif_renderings": "其他格式",
    "iiif_seeAlso": "另見",
    "import": "滙入",
    "importWorkspace": "滙入桌面排版",
    "importWorkspaceHint": "在此貼上Mirador 4排版設定碼",
    "item": "物件: {{label}}",
    "itemList": "標題列表",
    "jsError": "技術細節",
    "jsStack": "{{ stack }}",
    "language": "語言",
    "layer_hide": "隱藏圖層",
    "layer_move": "移動圖層",
    "layer_opacity": "圖層不透明度",
    "layer_show": "顯示圖層",
    "layers": "圖層",
    "light": "亮色主題",
    "links": "連結",
    "listAllOpenWindows": "切換至視窗",
    "login": "登入",
    "logout": "登出",
    "manifestError": "無法增添資源:",
    "maximizeWindow": "視窗最大化",
    "minimizeWindow": "視窗最小化",
    "mirador": "Mirador",
    "miradorResources": "Mirador資源",
    "miradorViewer": "Mirador閱覽器",
    "more": "更多...",
    "moreResults": "更多結果",
    "mosaic": "馬賽克",
    "mosaicDescription": "在桌面上以格狀方式排列視窗",
    "moveCompanionWindowToBottom": "移至下方",
    "moveCompanionWindowToRight": "移至右方",
    "multipartCollection": "多卷集合",
    "nextCanvas": "下一頁",
    "noItemSelected": "沒有物件被選中",
    "numItems_one": "{{number}} 項物件",
    "numItems_other": "{{number}} 項物件",
    "off": "關閉",
    "openCompanionWindow_annotations": "標註",
    "openCompanionWindow_attribution": "著作權",
    "openCompanionWindow_canvas": "目錄",
    "openCompanionWindow_info": "資訊",
    "openCompanionWindow_layers": "圖層",
    "openCompanionWindow_search": "搜索",
    "openInCompanionWindow": "移至新附屬視窗",
    "openWindows": "現有視窗",
    "pagination": "{{current}} / {{total}}",
    "position": "位置",
    "previewWindowTitle": "{{title}}",
    "previousCanvas": "上一頁",
    "related": "相關資訊",
    "resource": "資源",
    "retry": "重試",
    "right": "右方",
    "rights": "版權",
    "scroll": "滾動",
    "searchInputLabel": "搜索關鍵字",
    "searchNextResult": "下一個結果",
    "searchNoResults": "沒有搜索到結果",
    "searchPreviousResult": "前一個結果",
    "searchResultsRemaining": "{{numLeft}}剩餘",
    "searchSubmitAria": "提交搜索",
    "searchTitle": "搜索",
    "selectWorkspaceMenu": "選擇桌面排版方式",
    "showCollection": "顯示集合",
    "showingNumAnnotations_one": "顯示 {{number}} 項標註",
    "showingNumAnnotations_other": "顯示 {{number}} 項標註",
    "showZoomControls": "顯示縮放選項",
    "sidebarPanelsNavigation": "切換邊欄",
    "single": "單項",
    "startHere": "按此開始",
    "suggestSearch": "搜索本文檔以\"{{ query }}\"",
    "tableOfContentsList": "目錄",
    "theme": "佈景主題",
    "thumbnailList": "縮略圖列表",
    "thumbnailNavigation": "縮略圖",
    "thumbnails": "縮略圖",
    "toggleWindowSideBar": "切換邊欄開關",
    "totalCollections_one": "{{count}} 集合",
    "totalCollections_other": "{{count}} 集合",
    "totalManifests_one": "{{count}} 清單",
    "totalManifests_other": "{{count}} 清單",
    "tryAgain": "請重試",
    "untitled": "[無標題]",
    "view": "物件排列方式",
    "viewWorkspaceConfiguration": "查看工作區配置",
    "welcome": "歡迎使用Mirador",
    "window": "視窗: {{label}}",
    "windowMenu": "視窗視圖 & 縮略圖顯示",
    "windowNavigation": "切換視窗",
    "windowPluginButtons": "選項",
    "windowPluginMenu": "視窗選項",
    "workspace": "桌面",
    "workspaceFullScreen": "全螢幕",
    "workspaceMenu": "桌面設定",
    "workspaceNavigation": "工作區導航",
    "workspaceOptions": "桌面選項",
    "workspaceSelectionTitle": "選擇桌面排版方式",
    "zoomIn": "放大",
    "zoomOut": "縮小",
    "zoomReset": "重設縮放"
  }
}
